module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074be_logo_200x200.f50163b0.png";